'use client'
import { useHits, Pagination, useGeoSearch } from 'react-instantsearch'
import 'instantsearch.css/themes/algolia.css'

import {
  PageComponentMarketPage,
  PropertyCardNoResults,
} from '@/components/devlink'

import ApartmentCard from '@/components/ApartmentCard'
import { SearchBar } from '@/components/Search'

export default function SearchPage() {
  const { hits: apartments } = useHits()
  const { clearMapRefinement } = useGeoSearch()

  const resetSearchRuntimeProps = {
    onClick: () => clearMapRefinement(),
  }

  const props = {
    showHero: false,
    showBelowHero: false,
    showSearchHero: true,
    apartmentListSlot: apartments.length > 0
    ? apartments.map((apartment: any) =>
      <ApartmentCard key={apartment.id} {...apartment} />
    )
    : <PropertyCardNoResults resetSearchRuntimeProps={resetSearchRuntimeProps} />,
    copyBottomRichText: <Pagination />,
    relatedPagesSlot: <div />,
    searchBar: <SearchBar apartments={apartments} />,
  }
  return <PageComponentMarketPage {...props} />
}

